import Reports from "../../Lab Admin Tabs/Reports/Reports";
import CustomerReportsTab from "./CustomerReportsTab";

const CustomerReport = ({ TabConfig }) => {
  return <Reports showReNotifyButton={false} TabConfig={TabConfig} />;
};

export default CustomerReport;
